<template>
    <div>
        <local-similiarity-check
            @input="updateSimiliarities"
            v-model="localSimiliarities"
            :tryouts="tryouts"
            ref="local"
        ></local-similiarity-check>

        <remote-similiarity-check
            @input="updateSimiliarities"
            v-model="remoteSimiliarities"
            :tryouts="tryouts"
        ></remote-similiarity-check>

        <remote-question-bank-similiarity-check
            @input="updateSimiliarities"
            v-model="remoteQuestionBankSimilarities"
            :tryouts="tryouts"
        ></remote-question-bank-similiarity-check>
    </div>
</template>

<script>
import RemoteSimiliarityCheck from './RemoteSimiliarityCheck.vue'
import LocalSimiliarityCheck from './LocalSimiliarityCheck.vue'
import RemoteQuestionBankSimiliarityCheck from './RemoteQuestionBankSimiliarityCheck.vue'

/*
    Similiarity structure
    similiarities = [
        {questionId}: [
            {
                integer id: same question id,
                string question: question string of id,
                occurences: [ // Remote occurence
                    {
                        string tryout: tryout title where this question is used,
                        string period: period of the tryout
                    }
                ],
                localOccurence: { // When in local mode use this to automatically delete other occurence
                    integer tryoutIdx: affected tryout index
                    integer questionIdx: affected question index
                }
            }
        ]
    ]
*/

export default {
    props: {
        tryouts: {
            type: Array,
            required: true
        }
    },

    components: {
        RemoteSimiliarityCheck,
        LocalSimiliarityCheck,
        RemoteQuestionBankSimiliarityCheck
    },

    data: () => ({
        localSimiliarities: null,
        remoteSimiliarities: null,
        remoteQuestionBankSimilarities: null
    }),

    methods: {
        checkLocalSimiliarities() {
            this.$refs.local.check()
        },

        updateSimiliarities() {
            const result = {}

            const concatSimiliarity = (
                similiarities,
                tryoutIdx,
                questionIdx
            ) => {
                if (result[tryoutIdx] === undefined) {
                    result[tryoutIdx] = {}
                }

                if (result[tryoutIdx][questionIdx] === undefined) {
                    result[tryoutIdx][questionIdx] = []
                }

                result[tryoutIdx][questionIdx] = result[tryoutIdx][
                    questionIdx
                ].concat(similiarities[tryoutIdx][questionIdx])
            }

            const mergeSimiliarities = (
                similiarities,
                tryoutIdx,
                questionIdx
            ) => {
                if (
                    similiarities &&
                    similiarities[tryoutIdx] !== undefined &&
                    similiarities[tryoutIdx][questionIdx] !== undefined
                ) {
                    concatSimiliarity(similiarities, tryoutIdx, questionIdx)
                }
            }

            for (const tryoutIdx in this.tryouts) {
                const tryout = this.tryouts[tryoutIdx]

                for (const questionIdx in tryout.questions) {
                    mergeSimiliarities(
                        this.localSimiliarities,
                        tryoutIdx,
                        questionIdx
                    )
                    mergeSimiliarities(
                        this.remoteSimiliarities,
                        tryoutIdx,
                        questionIdx
                    )
                    mergeSimiliarities(
                        this.remoteQuestionBankSimilarities,
                        tryoutIdx,
                        questionIdx
                    )
                }
            }

            this.$emit('input', result)
        }
    }
}
</script>
